<template>
  <div>
    <el-container>
      <el-main>
        <el-row>
          <el-col :span="24">
            <ReportByProductByMonthFilters
              @onYearSelected="OnYearSelected"
              @thecnicianChaged="OnThecnicianChaged"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <ReportByModuleByMonthTable
              :yearSelected="yearSelected"
              :thecnicianSelected="thecnicianSelected"
            />
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ReportByProductByMonthFilters from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthFilters";
import ReportByModuleByMonthTable from "@/components/requests/reports/ReportByModuleByMonth/ReportByModuleByMonthTable";

const actualYear = new Date().getFullYear();

export default {
  name: "ClientRabbeyRequestByModule",
  components: {
    ReportByProductByMonthFilters,
    ReportByModuleByMonthTable
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: null,
      thecnicianSelected: 0,
      productId: null,
      productName: "",
      detailDialogVisible: false
    };
  },

  mounted() {},

  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnThecnicianChaged(thecnicianId) {
      this.thecnicianSelected = thecnicianId;
    }
  }
};
</script>
